import React from 'react';
import { Topbar, Aside, Main } from 'components';
import { numberFormatter } from 'components/misc/constants';
import useConfigOptions from 'hooks/useConfigOptions';
import { Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';

function Index() {
    const { loanProducts: loanTypes } = useConfigOptions();
    return (
        <main>
            <Topbar />

            <div className='pt-14 w-full flex overflow-hidden bg-light-bg dark:bg-dark-page'>
                <Aside />

                <Main>
                    <div className="space-y-6 py-4">

                        {/* Header */}
                        <div>
                            <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Apply for a Loan</h1>
                            <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
                                Choose a loan product that fits your needs
                            </p>
                        </div>

                        {/* Loan cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {loanTypes.map((loanType, index) => (
                                <Link
                                    key={index}
                                    to={`/loans/${loanType.path}`}
                                    className="group flex flex-col justify-between gap-4 rounded-xl border border-gray-200 dark:border-white/[.08] bg-white dark:bg-gray-900 p-5 shadow-sm hover:border-amber-300 dark:hover:border-amber-500/40 hover:shadow-md transition-all"
                                >
                                    <div>
                                        <p className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
                                            {loanType.name}
                                        </p>
                                        {loanType.summary && (
                                            <p className="text-xs text-gray-400 dark:text-gray-500 leading-relaxed">
                                                {loanType.summary}
                                            </p>
                                        )}
                                    </div>

                                    <div className="flex items-end justify-between">
                                        <div className="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
                                            <div>
                                                <p className="text-[10px] uppercase tracking-wider font-semibold text-gray-400 dark:text-gray-500 mb-0.5">Max</p>
                                                <p className="font-semibold text-gray-700 dark:text-gray-300">GHS {numberFormatter(loanType.limit)}</p>
                                            </div>
                                            <div className="w-px h-6 bg-gray-200 dark:bg-white/[.08]" />
                                            <div>
                                                <p className="text-[10px] uppercase tracking-wider font-semibold text-gray-400 dark:text-gray-500 mb-0.5">Rate</p>
                                                <p className="font-semibold text-gray-700 dark:text-gray-300">{loanType.rate}% p.m</p>
                                            </div>
                                        </div>

                                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-600 dark:text-amber-400 group-hover:gap-2 transition-all">
                                            Apply
                                            <HugeiconsIcon icon={ArrowRight01Icon} size={14} />
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>

                    </div>
                </Main>
            </div>
        </main>
    );
}

export default Index;
